var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessmentIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.547,
    height: 21.486,
    viewBox: "0 0 17.547 21.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488393",
    "data-name": "Group 488393",
    transform: "translate(0.25 0.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180745",
    "data-name": "Path 180745",
    d: "M183.126,171.4c0-2.283.043-4.567-.015-6.848a2.76,2.76,0,0,1,2.913-2.907c.122,0,.245-.011.365,0a.88.88,0,0,0,1.1-.607,1.5,1.5,0,0,1,1.5-.853c1.765-.01,3.531-.016,5.3,0a1.634,1.634,0,0,1,1.647,1.136.436.436,0,0,0,.5.325,9.715,9.715,0,0,1,1.455.058,2.557,2.557,0,0,1,2.253,2.571q.022,7.122,0,14.245a2.6,2.6,0,0,1-2.662,2.62q-5.843.039-11.687,0a2.634,2.634,0,0,1-2.666-2.761C183.118,176.054,183.126,173.725,183.126,171.4Zm1.463,0q0,3.4,0,6.8c0,1.049.441,1.487,1.5,1.488q5.547,0,11.094,0c1.079,0,1.506-.434,1.506-1.528q0-3.949,0-7.9c0-1.948,0-3.9,0-5.844a1.207,1.207,0,0,0-1.263-1.309,4.51,4.51,0,0,0-.865.01.55.55,0,0,0-.362.279,1.648,1.648,0,0,1-1.542,1.156c-2.009.019-4.017.014-6.026,0a1.434,1.434,0,0,1-1.425-.956c-.17-.487-.442-.532-.843-.5-.106.009-.213,0-.32,0-1,.007-1.452.454-1.453,1.443Q184.586,167.974,184.589,171.4Zm7-8.295c.928,0,1.855.006,2.783-.007a.518.518,0,0,0,.385-.146,1.016,1.016,0,0,0-.773-1.306h-4.608c-.653,0-.683.023-.833.642-.021.088-.022.182-.045.27-.1.389.015.563.445.553C189.829,163.09,190.712,163.1,191.594,163.1Z",
    transform: "translate(-183.11 -160.176)",
    fill: "#8e92a4",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180746",
    "data-name": "Path 180746",
    d: "M216.965,239.405c.45-.418.879-.8,1.292-1.2.39-.378.852-.435,1.158-.12s.279.723-.1,1.126c-.543.574-1.085,1.148-1.634,1.715-.466.48-.82.48-1.277.011-.308-.315-.617-.629-.915-.953a.738.738,0,0,1-.028-1.06.729.729,0,0,1,1.09.05C216.711,239.126,216.86,239.3,216.965,239.405Z",
    transform: "translate(-212.313 -230.78)",
    fill: "#8e92a4",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180747",
    "data-name": "Path 180747",
    d: "M216.98,303.419c.419-.4.821-.763,1.205-1.147.441-.442.895-.526,1.221-.2s.286.736-.149,1.192c-.534.561-1.063,1.126-1.6,1.681a.74.74,0,0,1-1.245-.005c-.308-.315-.617-.629-.915-.953a.738.738,0,0,1-.011-1.092.731.731,0,0,1,1.057.066C216.7,303.114,216.852,303.283,216.98,303.419Z",
    transform: "translate(-212.312 -288.93)",
    fill: "#8e92a4",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180748",
    "data-name": "Path 180748",
    d: "M282,249.646c-.623,0-1.246.007-1.869,0-.5-.007-.78-.261-.8-.684a.707.707,0,0,1,.768-.77q1.892-.024,3.784,0a.712.712,0,0,1,.774.766c-.013.424-.3.681-.791.688C283.249,249.653,282.626,249.646,282,249.646Z",
    transform: "translate(-270.548 -240.141)",
    fill: "#8e92a4",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180749",
    "data-name": "Path 180749",
    d: "M282.012,313.657c-.623,0-1.246.006-1.869,0-.52-.007-.808-.272-.806-.72a.717.717,0,0,1,.8-.736q1.846-.019,3.693,0c.537,0,.839.3.83.759-.009.439-.3.693-.828.7C283.227,313.662,282.619,313.657,282.012,313.657Z",
    transform: "translate(-270.547 -298.305)",
    fill: "#8e92a4",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment-icon.b1b2b43a3bb32bae2f6c29c574aa504e.svg";
export { ForwardRef as ReactComponent };